module.exports = __webpack_public_path__ + "img/monero.98410fd7.svg";